import { Order } from 'shell/view-models/order';
import {
  filtersOperationObjectToQueryString,
  OperationObject,
} from './filters-object-to-query-string-batch-event';
import {
  ordersObjectToQueryString,
  QuerySerializableObject,
} from './orders-object-to-query-string';

export const paginationListToQueryStringForBatchAndEventManager = (
  values: CommonFieldsForList
): string => {
  const { orders, page, rowsPerPage, filters } = values;

  const filtersQueryString = filtersOperationObjectToQueryString(filters);

  const interpolationFilters = filtersQueryString ? `${filtersQueryString || ''}` : '';

  const ordersObject = orders || {};

  const orderQueryString = ordersObjectToQueryString(
    'sort',
    ordersObject as QuerySerializableObject
  );

  // const pageOffset = (page || 0) * (rowsPerPage || 0);
  const hasPagination = page !== undefined && rowsPerPage !== undefined;

  const paginationString = hasPagination ? `page=${page}&size=${rowsPerPage}` : '';

  const queryString = [
    paginationString,
    interpolationFilters && `&${interpolationFilters}`,
    orderQueryString && `&${orderQueryString}`,
  ]
    .filter((str) => !!str)
    .join('');

  return queryString;
};

type CommonFieldsForList = {
  filters: OperationObject;
  orders: Order;
  page?: number;
  rowsPerPage?: number;
};
